import { render, staticRenderFns } from "./FieldPermissionCrud.vue?vue&type=template&id=68081918"
import script from "./FieldPermissionCrud.vue?vue&type=script&lang=js"
export * from "./FieldPermissionCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports